<template>
  <div class="bottom">
    <div class="auto">
      <div class="bottom-bottom ytable">
        <div class="bottom-bottom-logo">
          <img src="../assets/logo_2@2x.png" alt="" />
        </div>
        <div class="content ytable-cell">
          <div class="links" v-if="lan === 0">
            <span
              ><router-link :to="{ name: 'visitor', query: { columnId: 6 } }"
                >联系我们</router-link
              ></span
            >
          </div>
          <div class="links" v-else-if="lan === 1">
            <span
              ><router-link :to="{ name: 'visitor', query: { columnId: 6 } }"
                >About Us</router-link
              ></span
            >
          </div>
          <div class="copyright" v-if="lan === 0">
            <div>地址：广州市花都区炭步镇朗头村青云路18号</div>
            <div>电话：020-22262888</div>
            <div>邮箱：chunyangtai@langchuanculture.cn</div>
          </div>
          <div class="copyright" v-else-if="lan === 1">
            <div>
              Add: NO.18 Qingyun Road, Langtou Village,Tanbu Town, Huadu
              District, Guangzhou, China
            </div>
            <div>Tel: 020-22262888</div>
            <div>Email: chunyangtai@langchuanculture.cn</div>
          </div>
          <div class="bottom-certificate">
            <a
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
              target="_self"
              >©️2024 CHUN YANG TAI 粤ICP备2023112445号</a
            >
          </div>
        </div>
        <div class="bottom-bottom-right">
          <div class="links" v-if="lan === 0">
            <span>关注我们</span>
          </div>
          <div class="links" v-else-if="lan === 1">
            <span>Contact Us</span>
          </div>
          <div class="bottom-links-icon">
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content=""
            >
              <img src="../assets/WeChatQRcode.jpg" />
              <img slot="reference" src="../assets/weixin@2x.png" />
            </el-popover>
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content=""
            >
              <img src="../assets/XiaohongshuQRcode.jpeg" />
              <img slot="reference" src="../assets/xiaohonshu@2x.png" />
            </el-popover>
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content=""
            >
              <img src="../assets/TiktokQRcode.jpg" />
              <img slot="reference" src="../assets/douyin@2x.png" />
            </el-popover>
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content=""
            >
              <img src="../assets/BilibiliQRcode.png" />
              <img slot="reference" src="../assets/bilibili@2x.png" />
            </el-popover>
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content=""
            >
              <img src="../assets/EnterpriseWeChatQRcode.jpg" />
              <img slot="reference" src="../assets/qiyehao@2x.png" />
            </el-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "bottom",
  props: {
    Index: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isIndex: this.Index,
      menuList: [],
      info: this.$store.state.publicInfo,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    this.menuList = [];
    let menuList = [];
    window.addEventListener("scroll", this.scrollTop, true);
    if (
      localStorage.getItem("routeList") === null ||
      localStorage.getItem("publicInfo") === null
    ) {
      this.init();
    } else {
      try {
        menuList = JSON.parse(localStorage.getItem("routeList"));
        menuList.pop();
        menuList.shift();
        this.info = JSON.parse(localStorage.getItem("publicInfo"));
        this.menuList = menuList;
      } catch (err) {
        console.log(err);
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop, true);
  },
  methods: {
    init() {},
    toTop() {
      var timer = setInterval(function () {
        const osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        const ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    /* eslint-disable no-undef */
    dealShare(event, type) {
      bShare.addEntry({
        url: location.href,
        title: "Guangdong vipshop Charitable Foundation",
        summary: "Web Sharing",
      });
      if (type !== "more") {
        bShare.share(event, type, 0);
        return false;
      } else {
        bShare.more(event);
        return false;
      }
    },
  },
};
</script>
<style scoped>
.bottom {
  background-color: #000000;
  background-size: cover;
  min-width: 320px;
}
.bottom .bottom-top {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  line-height: 140px;
}

.bottom .share li:first-child a {
  background: url(../assets/sina.png) no-repeat center;
}
/* .bottom .share li:nth-child(2) a{background: url(../assets/facebook.png)no-repeat center;}
.bottom .share li:nth-child(3) a{background: url(../assets/sina.png)no-repeat center;} */
.bottom .share li:last-child a {
  background: url(../assets/wechat.png) no-repeat center;
}
.bottom .share li:last-child {
  margin-left: 0;
}

.bottom .bottom-bottom {
  width: 95%;
  height: 360px;
  position: relative;
  display: flex;

  justify-content: space-between;
  margin: 0 auto;
  padding-top: 106px;
}
.bottom-bottom-logo {
  width: 105px;
  height: 44px;
}

.bottom .links,
.bottom .links a {
  font-size: 14px;
  color: #fff;
  font-weight: lighter;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
}
.bottom .links a {
  cursor: pointer;
}
.bottom .links span:first-child a {
  margin-left: 0;
}
.bottom .copyright {
  padding-top: 1%;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989f;
  line-height: 28px;
  font-weight: 400;
}
.bottom .copyright,
.bottom .copyright a {
  font-weight: lighter;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  transition: all 0.3s ease-in-out;
}
.bottom .copyright a:hover {
  color: #fff;
}
.bottom-links-icon {
  display: flex;
  margin-top: 20px;
}
.bottom-links-icon img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}
.bottom-certificate {
  padding-top: 60px;
}
.bottom-certificate a {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989f;
  font-weight: Regular;
}
@media (max-width: 1440px) {

.bottom .bottom-bottom {
  width: 93%;
  height: 360px;
  position: relative;
  display: flex;

  justify-content: space-between;
  margin: 0 auto;
  padding-top: 106px;
}
}
@media (max-width: 1200px) {
  .bottom .infor-box {
    padding-left: 0;
    float: none;
  }
  .bottom .qrcode {
    position: initial;
    width: 132px;
  }
  .bottom .qrcode .box {
    display: inline-block;
    width: 100%;
  }
}
@media (max-width: 1024px) {
  .bottom .fl dt a {
    font-size: 15px;
  }
  .bottom .fl dd a {
    font-size: 14px;
  }
  .bottom .entitle {
    font-size: 28px;
  }
}
@media (max-width: 960px) {
  .bottom .fl {
    display: none;
  }
  .bottom .fr {
    width: 100%;
  }
  .bottom .qrcode {
    margin: 0 auto;
  }
  .bottom .infor-box {
    float: none;
    text-align: center;
    padding-top: 1%;
  }
  .bottom .infor {
    padding-top: 1%;
  }
  .bottom .infor > div {
    padding: 1% 0;
  }
  .bottom .copyright {
    padding-right: 0;
  }
}
@media (max-width: 640px) {
  .bottom .share {
    width: 220px;
  }
  .bottom .title {
    font-size: 26px;
  }
  .bottom .entitle {
    line-height: 1.5;
    padding-top: 3%;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .bottom .bottom-logo.isIndex.en::after,
  .bottom .bottom-logo.isIndex::after {
    content: none;
  }
  .bottom .fr {
    text-align: center;
  }
  .bottom .qrcode .box {
    width: 96px;
    margin: 0 auto;
  }
  .bottom .qrcode .txt {
    padding: 3% 0;
  }
  .bottom .qrcode {
    margin: 10px auto;
  }
  .bottom-bottom {
    display: block;
  }
  .bottom .copyright {
    line-height: 1.5;
    padding: 1% 2%;
  }
  .bottom .copyright a {
    line-height: 1.5;
  }
  .bottom .share {
    float: none;
    margin: 0 0 0 auto;
    height: 80px;
  }
  .bottom .bottom-top {
    line-height: 80px;
  }
  .bottom .to-top.mar {
    position: initial;
    margin-top: 5%;
  }
  .bottom .content {
    text-align: center;
  }
  .bottom .title {
    width: 100%;
  }
  .bottom .entitle {
    font-size: 20px;
  }
  .bottom .links a {
    font-size: 12px;
  }
}
</style>
